import { clsx } from 'clsx';
import { TabsContent } from 'src/components/ui/tabs';
import { PersonaTabSkeleton } from 'src/pages/ConfigurationPage/PersonaTab/PersonaTabSkeleton/PersonaTabSkeleton';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { WorkflowsForm } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowsForm/WorkflowsForm';
import type { Workflow } from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';
import type { WorkflowListKey } from 'src/pages/ConfigurationPage/hooks/useConfigurationWorkflows';
import type { ConfigurationFormFieldsObject } from 'src/pages/ConfigurationPage/hooks/useConfigurationFormFields';
import { CustomConfigurationMessage } from 'src/components/CustomConfigurationMessage/CustomConfigurationMessage';

export const WorkflowsTab = ({
  isLoading,
  formFieldsObject = {} as ConfigurationFormFieldsObject,
  readonly,
  onWorkflowsChange = (() => {}) as (key: WorkflowListKey, data: Workflow[]) => void,
  onWorkflowAdd = (() => {}) as (workflow: Workflow) => void,
  onEditClick = () => {},
  defaultWorkflows,
  customWorkflows,
}: {
  isLoading?: boolean;
  formFieldsObject?: ConfigurationFormFieldsObject;
  readonly?: boolean;
  onWorkflowsChange?: (key: WorkflowListKey, data: Workflow[]) => void;
  onWorkflowAdd?: (workflow: Workflow) => void;
  onEditClick?: () => void;
  defaultWorkflows?: Workflow[];
  customWorkflows?: Workflow[];
}) => {
  const formFieldsLength = Object.keys(formFieldsObject).length;

  return (
    <TabsContent
      className={clsx('p-0 mt-0 h-full rounded-sm-5 overflow-auto pr-2')}
      value={'workflows'}
    >
      <LoaderWrapper isLoading={isLoading} loader={<PersonaTabSkeleton />}>
        {formFieldsLength ? (
          <WorkflowsForm
            onWorkflowsChange={onWorkflowsChange}
            onWorkflowAdd={onWorkflowAdd}
            onEditClick={onEditClick}
            defaultWorkflows={defaultWorkflows}
            customWorkflows={customWorkflows}
            formFieldsObject={formFieldsObject}
            readonly={readonly}
            compact={true}
          />
        ) : (
          <CustomConfigurationMessage />
        )}
      </LoaderWrapper>
    </TabsContent>
  );
};
